import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import HFQuantitiesGroup from 'components/HFInputs/HFQuantitiesGroup'
import styles from '../../controllers/Dialog.module.sass'

const TaskMedicalActsController = (props) => {
	const { requisition } = props
	const { i18n } = useGlobal()

	return (
		<>
			{requisition?.exams && requisition?.exams.length > 0 && (
				<fieldset>
					<HStack gap='xsmall'>
						<h4>
							{requisition?.type?.id === 6
								? i18n`Medical Acts`
								: i18n`Pre-operative`}
						</h4>
						<h4 className={styles['counter']}>
							{requisition?.exams?.length || 0}
						</h4>
					</HStack>
					<HFQuantitiesGroup
						name={'exams'}
						data={requisition?.exams || []}
						booleanInput={true}
						hasLaterality={false}
					/>
				</fieldset>
			)}
		</>
	)
}

export default TaskMedicalActsController
